
<template>
  <!--推送-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="push_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <span slot="iOS"><a-icon type="smile-o"/>目标 | 成功</span>
      <span slot="Android"><a-icon type="smile-o"/>目标 | 成功</span>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'push',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: '推送标题', inputType: 'input' },
        { props: ['push_os'], placeholder: '目标平台', options: [], inputType: 'select' },
        { props: ['push_app'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['scope_type'], placeholder: '用户范围', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.pushStatusList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.push_id), key: 'detail' },
        { text: '撤回', handle: (row) => this.cancel(row.push_id), key: 'cancel' }
      ],
      columns: [
        { title: '推送时间', dataIndex: 'send_time', align: 'left', width: '' },
        { title: '推送标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用', dataIndex: 'push_app_desc', align: 'left', width: '' },
        { title: '用户范围', dataIndex: 'scope_type', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_title', align: 'left', width: '' },
        // { title: '目标 | 成功', dataIndex: 'ios_total', align: 'left', width: '', slots: {title: 'iOS'} },
        // { title: '目标 | 成功', dataIndex: 'android_total', align: 'left', width: '', slots: {title: 'Android'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: '',
        push_os: '',
        push_app: '',
        scope_type: '',
        status: '',
        create_date: ''
      },
      listApi: {
        url: '/push',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addPush',
        title: ''
      },
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        { index: 1, query: 'push_aims_type_desc', scope: 'searchList' },
        { index: 2, query: 'message_aims_type_desc', scope: 'searchList' },
        { index: 3, query: 'scope_type_desc', scope: 'searchList' }
      ];
      paramArr.forEach((el) => {
        this.typeSelect(el);
      });
    },
    /* 进入详情页面 */
    toDetail (id) {
      this.$router.push({
        name: 'pushDetail',
        query: { id: id }
      });
    },
    /* 撤销推送 */
    cancel (id) {
      this.$confirm({
        title: '确定要撤回该条推送？',
        centered: true,
        onOk: (close) => {
          close();
          this.$put({
            url: `/push/${id}/cancel`,
            params: {}
          }).then((res) => {
            this.$message.success('撤回成功！');
            this.$children[0].getTableList();
          });
        }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/push/push.vue